import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { Paper, Grid } from "@material-ui/core";
import MapTopbar from "../../../components/m4k/batItem/topbar";
import BatLeft from "../../../components/m4k/batItem/batLeft";
import BatMid from "../../../components/m4k/batItem/batMid";
import BatRight from "../../../components/m4k/batItem/batRight";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    girdRoot: {
      width: "100vw",
      height: "100vh",
      background:
        "linear-gradient(178deg,rgba(0,74,132,1) 0%,rgba(3,16,40,1) 100%)",
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: "center",
      color: theme.palette.text.secondary,
    },
    topbar: {
      height: "10vh",
    },
    gridItem: {
      height: "90vh",
    },
    gridItem2: {
      height: "90vh",
      width: "29vw",
    },
  })
);

const Battery: React.FC = (props) => {
  const classes = useStyles();
  document.title = "新能源电池";

  return (
    <Grid
      className={classes.girdRoot}
      container
      direction="row"
      alignItems="center"
      justify="center"
    >
      <Grid item xs={12} className={classes.topbar}>
        <MapTopbar />
      </Grid>
      <Grid item className={classes.gridItem2}>
        <BatLeft />
      </Grid>
      <Grid item xs={5} className={classes.gridItem}>
        <BatMid />
      </Grid>
      <Grid item className={classes.gridItem2}>
        <BatRight />
      </Grid>
    </Grid>
  );
};

export default Battery;
